import axios from 'axios';
import { getApi } from './util/getApi';
import { store } from 'store/store';

const fetchURL = process.env.REACT_APP_API_URL + '/project';

const api = getApi(fetchURL);

export const createProject = (data: {
  project_name: string;
  project_description: string;
  program_id: number | null;
  start_date_time: string;
  end_date_time: string;
  location: string;
  causeIds: Array<number>;
}) => api.post('/insertDocument', data).then((r) => r.data);

export const updateProject = (data: {
  id: number;
  causeIds: Array<number>;
  activityIds: Array<number>;
  postIds: Array<number>;
}) => api.post('/updateDocument', data).then((r) => r.data);

export const getProjectByID = (data: { project_id: number }) =>
  api.post('/retrieveDocument', data).then((r) => r.data);

export const getProjectByUser = (data: { user_id: number }) =>
  api.post('/retrieveDocumentByUser', data).then((r) => r.data);

export const linkEvents = async (data: {projectId: number, eventIds: number[]}) => {
  return await api.post('/linkActivities', data).then((r) => r.data)
}

export const linkPosts = async (data: {projectId: number, postIds: number[]}) => {
  return await api.post('/linkPosts', data).then((r) => r.data)
}